// extracted by mini-css-extract-plugin
export default {"contactForm":"ContactForm_contactForm__F-TWC","contactFormHeading":"ContactForm_contactFormHeading__5QUMO","contactFormSubHeading":"ContactForm_contactFormSubHeading__ZgaWZ"};